import React from 'react';
import TuerSettings from './TuerSettings.jsx';
import KorpusSettings from './KorpusSettings.jsx';
import BodenSettings from "./BodenSettings.jsx";
import SchubladenSettings from "./SchubladenSettings.jsx";
import ProductDragSettings from "./ProductDragSettings.jsx";
import ElementSettings from "./ElementSettings.jsx";
import Stammdaten from "./Stammdaten.jsx";
import DekorSettings from "./DekorSettings.jsx";
import GriffeSettings from "./GriffeSettings.jsx";
import SchwebetuerenSettings from "./SchwebetuerenSettings.jsx";
import TrennwandboxSettings from "./TrennwandboxSettings.jsx";
import NeuerSchrankSettings from './NeuerSchrankSettings.jsx';

export default class Sidebar extends React.Component {

    render() {
        switch(this.props.state.type) {
            case 'korpus':
                return <KorpusSettings />;
            case 'tuer':
                return <TuerSettings  model={this.props.model.currentContext}/>;
            case 'boden':
                return <BodenSettings model={this.props.model.currentContext} />;
            case 'trennwandbox':
                return <TrennwandboxSettings model={this.props.model.currentContext} />;
            case 'schublade':
                return <SchubladenSettings model={this.props.model.currentContext} />;
            case 'tueren':
                if (APP.arrangement.selectedSchrank.isSchwebetuer) {
                    return <SchwebetuerenSettings/>;
                } else {
                    return <ProductDragSettings products={APP.findProductsByReiter('Tueren')} model={this.props.model.currentContext} title={I18N('Türen')} />;
                }
            case 'einbauten': {
                let einbauten = APP.findProductsByReiter('Ausstattung');
                if (APP.arrangement.isSchwebetuer) {
                    einbauten = einbauten.filter(x=>!x.NichtBeiSchiebetueren);
                }
                return <ProductDragSettings products={einbauten} title={I18N('Ausstattung')} />;
            }
            case 'stammdaten':
                return <Stammdaten />
            case 'elemente':
                return <ElementSettings model={this.props.model.currentContext}/>
            case 'dekore':
                return <DekorSettings />
            case 'griffe':
                if (!APP.arrangement.selectedSchrank.isSchwebetuer) {
                    return <GriffeSettings />
                }
            case 'neuerSchrank':
                return <NeuerSchrankSettings sidebarBefore={this.props.state.sidebarBefore} schrank={this.props.state.schrank} direction={this.props.state.direction}></NeuerSchrankSettings>
            default:
                return null;
        }
    }

}
